module.exports = function() {
  return new Worker(__webpack_public_path__ + "b445aa299e59477d4bea.worker.js");
};